import * as React from 'react';
import styles from './PrintButton.module.scss';
import { useEffect, useState } from 'react';
import jsPDF from 'jspdf';
import WishlistItem from '../Wishlist/WishlistItem';
import html2canvas from 'html2canvas';

export const PrintButton = ({ isWishlistEmpty }) => {
  const componentRef = React.useRef(null);
  const [isPrintButtonActive, setIsPrintButtonActive] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  const storedItems = JSON.parse(localStorage.getItem('wishlistStorage')) ?? [];

  const getMagicLink = () => {
    const storedItems = JSON.parse(localStorage.getItem('wishlistStorage')) ?? [];
    let link = 'https://www.leroymerlin.pl/klient/przenies-do-koszyka.html';

    storedItems.forEach((item, index) => {
      if (index === 0) link += '?';
      else link += '&';

      link += `r=${item}&q=1`;
    });
    return link;
  };

  useEffect(
    (_) => {
      if (isPrinting) handleDownload();
    },
    [isPrinting]
  );

  const handleDownload = () => {
    html2canvas(componentRef.current).then((canvas) => {
      const imgWidth = 208;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;
      heightLeft -= pageHeight;
      const doc = new jsPDF('p', 'mm');
      doc.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
        heightLeft -= pageHeight;
      }
      doc.save(`lista-zyczen_${new Date().toJSON().slice(0, 10)}.pdf`);
      setIsPrinting(false);
    });
  };

  return (
    !isWishlistEmpty && (
      <>
        <div className={styles.btnPrintList} onClick={(_) => setIsPrintButtonActive((prevState) => !prevState)}>
          Pobierz listę
          {isPrintButtonActive && (
            <div className={styles.selectButtons}>
              <button onClick={(_) => window.open(getMagicLink(), '_blank').focus()}>Przenieś produkty do koszyka</button>
              <button onClick={(_) => setIsPrinting(true)} type="button">
                Pobierz jako .pdf
              </button>
            </div>
          )}
        </div>
        <div className={styles.productsListWrapper}>
          {isPrinting && <div className={styles.productsListOverlay}></div>}
          <ul>
            {storedItems?.map((itemID) => (
              <WishlistItem id={itemID} key={itemID} />
            ))}
          </ul>
          <ul ref={componentRef} className={`${styles.printList} ${isPrinting ? '' : styles.displayNone}`}>
            {storedItems?.map((itemID) => (
              <WishlistItem id={itemID} key={itemID} type="toPrint" />
            ))}
          </ul>
        </div>
      </>
    )
  );
};
